module.exports = __webpack_public_path__ + "static/media/pulse-new-hire.a9dde08a.svg";